import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useGetRecommendedCampaignsApiCallQuery } from "@/services/api/campaigns/campaigns.api";
import { ArrowRight } from "lucide-react";
import React from "react";
import Loader from "@/components/Loader";

const RecommendedCampaign = () => {
  const {
    data: recommendedCampaignsData,
    isError: recommendedCampaignsError,
    isLoading,
  } = useGetRecommendedCampaignsApiCallQuery();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <Loader size="lg" text="Loading recommended campaigns..." />
      </div>
    );
  }

  return (
    <div>
      <div className="flex flex-col md:flex-row md:items-center justify-between mb-6">
        <h2 className="text-xl md:text-2xl text-white">Recommended For You</h2>
        {/* <Link to={DASHBOARD_PATH?.RECOMMENDED_CAMPAIGNS}>
          <Button
            variant="outline"
            className="border-yellow-500 text-yellow-400 hover:bg-yellow-500 hover:text-black mt-4 md:mt-0"
          >
            Explore More
          </Button>
        </Link> */}
      </div>

      <div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {recommendedCampaignsData?.result &&
            recommendedCampaignsData?.result?.length > 0 &&
            recommendedCampaignsData?.result.map((campaign) => (
              <Card
                key={campaign._id}
                className="bg-gray-900/50 border-yellow-500/20 hover:border-yellow-500/40 transition-colors"
              >
                <CardContent className="p-4 md:p-6">
                  <div className="flex items-center justify-between mb-4">
                    <h3 className="text-white text-base md:text-lg">
                      {campaign.name}
                    </h3>
                    <Badge
                      variant="outline"
                      className="border-yellow-500 text-yellow-400"
                    >
                      New
                    </Badge>
                  </div>

                  <div className="grid grid-cols-3 gap-4 mb-4">
                    <div className="text-center">
                      <div className="text-white">{campaign.airdropAmount}</div>
                      <div className="text-gray-400 text-xs">BINGOLD</div>
                    </div>
                    <div className="text-center">
                      <div className="text-white">{campaign.totalTasks}</div>
                      <div className="text-gray-400 text-xs">Tasks</div>
                    </div>
                    <div className="text-center">
                      <div className="text-white">{campaign.userJoined}</div>
                      <div className="text-gray-400 text-xs">Joined</div>
                    </div>
                  </div>

                  <Button
                    variant="outline"
                    className="w-full border-yellow-500 text-yellow-400 hover:bg-yellow-500 hover:text-black"
                  >
                    Start Campaign
                    <ArrowRight className="w-4 h-4 ml-2" />
                  </Button>
                </CardContent>
              </Card>
            ))}
        </div>

        {(recommendedCampaignsError ||
          recommendedCampaignsData?.result?.length === 0) && (
          <div className="mt-4">
            <p>No Campaigns Found!</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default RecommendedCampaign;
